import React from "react";
import Keycloak from "keycloak-js";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { SessionAuthProvider } from "./SessionAuthContext";
import { useAppConfig } from "../context/ConfigContext";



const eventLogger = (event, error) => {
  //console.log("onKeycloakEvent", event, error);
};

const tokenLogger = (tokens) => {
  //console.log("onTokens", tokens);
};

const KeycloakProvider = ({ children }) => {
  const { url, realm, clientId } = useAppConfig();

  const keycloak = new Keycloak({
  url: url,
  realm: realm,
  clientId: clientId,
});

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{ onLoad: "login-required", checkLoginIframe: true }}
      onEvent={eventLogger}
      onTokens={tokenLogger}
    >
      <SessionAuthProvider>
          {children}
      </SessionAuthProvider>
    
    </ReactKeycloakProvider>
  );
};

export default KeycloakProvider;
